import { render, staticRenderFns } from "./ToolsView.vue?vue&type=template&id=21176330&scoped=true&"
import script from "./ToolsView.vue?vue&type=script&lang=ts&"
export * from "./ToolsView.vue?vue&type=script&lang=ts&"
import style0 from "./ToolsView.vue?vue&type=style&index=0&id=21176330&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21176330",
  null
  
)

export default component.exports